import ApiService from '@/services/api.service';

export async function getRandomDashboardMessage() {
    const response = await ApiService.get("dashboardmessage/random");
    return response.data;
}